import Swiper, {Parallax, Pagination, Autoplay, EffectFade} from 'swiper'
// import 'swiper/modules/effect-fade/effect-fade.scss'
import 'swiper/css/effect-fade'

document.addEventListener('DOMContentLoaded', () => {
    const sliderWrappers = document.querySelectorAll('.mtt-product-slider')

    if (sliderWrappers.length > 0) {
        sliderWrappers.forEach(sliderWrapper => {
            const swiperElement = sliderWrapper.querySelector('.mtt-product-slider__swiper')
            const pagination = sliderWrapper.querySelector('.swiper-pagination-custom')
            const paginationTitles = sliderWrapper.querySelectorAll('[data-pagination-title]')

            const swiperOptions = {
                modules: [Parallax, Pagination, Autoplay, EffectFade],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 1200,
                spaceBetween: 100,
                slidesPerView: 1,
                loop: true,
                parallax: true,
                grabCursor: true,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: pagination,
                    type: 'bullets',
                    clickable: true,
                    renderBullet: (index, className) => {
                        const paginationTitle = paginationTitles[index].getAttribute('data-pagination-title')
                        return bulletMarkup(className, paginationTitle)
                    }
                }
            }

            const swiper = new Swiper(swiperElement, swiperOptions)

            swiper.on('slideChange', () => swiperElement.classList.add('swiper-changed'))

            /*swiperElement.addEventListener('mouseenter', function () {
                swiper.autoplay.stop()
            })

            swiperElement.addEventListener('mouseleave', function () {
                swiper.autoplay.start()
            })*/
        })
    }

    function bulletMarkup(className, title) {
        return (
            `<div class="${className}">
                <div class="swiper-pagination-progress"></div>
                <div class="swiper-pagination-bullet__title">${title}</div>
            </div>`
        )
    }
})
